import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CalculatedFilterCreate = lazy(() =>
  import("@segments/CalculatedFilterEdit").then((module) => ({
    default: module.CalculatedFilterCreateNRO,
  }))
);

export const calculatedFiltersCreateNRO: NavigationRoutingObject = {
  Component: CalculatedFilterCreate,
  componentFeatureFlippers: ["calculated_filters"],
  noKnockoutFallback: true,
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) => t("calculated-filters-create-heading", "Create Calculated Filter"),
  pageNameForTracking: () => "Create Calculated Filter",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("calculated-filters-create-description", "Create a calculated filter"),
  icon: "nav-system-calculated-filters",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("calculated_filters");
  },
  showInSearchResults: false,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/calculated_filters/:appGroupId",
};
